import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

// ✅ FIXED BASE URL
const BASE = `${API}userguide/api-docs/`;

const ApiDocService = {

  getDocs() {
    return axios.get(BASE, {
      headers: authHeader(),
    });
  },

  getDoc(id) {
    return axios.get(`${BASE}${id}/`, {
      headers: authHeader(),
    });
  },

  createDoc(data) {
    return axios.post(BASE, data, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
  },

  updateDoc(id, data) {
    return axios.put(`${BASE}${id}/`, data, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
  },

  deleteDoc(id) {
    return axios.delete(`${BASE}${id}/`, {
      headers: authHeader(),
    });
  },

  globalSearch(query) {
    return axios.get(`${BASE}search/`, {
      params: { q: query },
      headers: authHeader(),
    });
  },
};

export default ApiDocService;